<template>
  <transition name="product">
    <div class="ClueEntry2">
      <van-nav-bar
        fixed
        title="我的项目"
        left-arrow
        @click-left="onClickLeft"
      />
      <b-row>
        <b-col md="12 mt-5 mb-30">
          <b-card>
            <b-row>
              <b-form-group
                class="col-md-6 mb-3"
                label="项目名称"
                label-for="input-1"
              >
                <b-form-input
                  v-model="form.ProjectName"
                  type="text"
                  required
                  placeholder="请输入项目名称"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                class="col-md-6 mb-3"
                label="企业名称"
                label-for="input-1"
              >
                <b-form-input
                  v-model="form.CompanyName"
                  type="text"
                  required
                  placeholder="请输入企业名称"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="项目状态"
                label-for="input-1"
                class="col-md-6 mb-3"
              >
                <b-form-select
                  v-model="form.Status"
                  :options="options3"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </b-form-group>
              <b-col md="12 text-center">
                <b-button class="mt-3 w-50 button-color" @click="search(1)" variant="primary"
                  >查询</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="search"
      >
        <b-row>
          <b-col cols="12" v-for="(item, index) in list" :key="index">
            <b-card style="width:95%;margin:0 auto;" class="mt-3 card-icon-bg card-icon-bg-primary o-hidden">
              <div class="content d-flex van-row--justify-space-between">
                <p class="card-title text-break">{{ item.projectName }}</p>
                <div class="d-flex card-title" style="align-items: center">
                  <van-tag
                    class="parmary-color text-nowrap"
                    style="margin: 0 10px"
                    >{{ item.natureName }}</van-tag
                  >
                  <van-tag class="parmary-color text-nowrap">{{
                    item.stausDescription
                  }}</van-tag>
                </div>
              </div>
              <div class="d-flex justify-content-between fontSize">
                <span>项目名称：{{ item.projectName }}</span>
                <span
                  >项目名称：{{
                    item.creationTime | format("YYYY-MM-DD")
                  }}</span
                >
              </div>
              <div class="mt-2 fontSize d-flex">
                <div style="width: 18%" class="text-nowrap text-break">
                  项目概述：
                </div>
                <div style="width: 83%" class="text-monospace">
                  {{ item.projectDescription }}
                </div>
              </div>
              <div class="mt-2 fontSize d-flex van-row--justify-space-between">
                <div>{{ item.companyName }}</div>
                <div>{{ item.industry }}</div>
              </div>
              <div class="mt-2 fontSize">
                <div>联系人：{{ item.contactPerson }}</div>
                <div>联系电话：{{ item.contactNumber }}</div>
              </div>
              <div v-if="item.status == 20">
                <div
                  class="pt-2 fontSize border-top mt-2 border-bottom-dotted-gray-1"
                >
                  <div>驳回原因：{{ item.reason || "无" }}</div>
                  <div>{{ item.creationTime }}</div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </van-list>
    </div>
  </transition>
</template>
<script>
export default {
  name: "MyProject",
  data() {
    return {
      loading: false,
      finished: false,
      options3: [
        { value: "", text: "请选择" },
        { value: 0, text: "待分配经办人" },
        { value: 10, text: "待初审" },
        { value: 20, text: "驳回" },
        { value: 30, text: "已立项" },
        { value: 40, text: "二次洽谈确认" },
        { value: 50, text: "专家评估" },
        { value: 60, text: "分管领导审核" },
        { value: 61, text: "分管领导审核-征集部门意见" },
        { value: 62, text: "分管领导审核-上会" },
        { value: 70, text: "科室领导审核" },
        { value: 71, text: "科室领导审核-停止项目" },
        { value: 72, text: "科室领导审核-征集部门意见" },
        { value: 73, text: "科室领导审核-上会" },
        { value: 74, text: "科室领导审核-专家评估" },
        { value: 80, text: "征集财政司法等部门意见" },
        { value: 90, text: "主管领导审核-上会" },
        { value: 100, text: "上会/审签" },
        { value: 110, text: "签约落地" },
        { value: 120, text: "已签约" },
        { value: 130, text: "已停止" },
      ],
      list: [],
      form: {
        Status: "",
        CompanyName: "",
        ProjectName: "",
        PageSize: 5,
        PageIndex: 0,
        CheckStatus: "",
      },
    };
  },
  methods: {
    search(val) {
      if (val) {
        this.list = [];
        this.form.PageIndex = 0;
      }
      this.form.PageIndex += 1;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.request({
        url: "/v1.0/ThePublic/getMyProjectList",
        method: "GET",
        params: this.form,
      }).then((res) => {
        this.$toast.clear();
        if (res.success) {
          res.data.items.map((item) => {
            this.list.push(item);
          });
          if (res.data.totalCount == this.list.length) {
            this.finished = true;
          }
        }
        this.loading = false;
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.button-color {
  background: $button-color;
  border-color: $button-color;
}
.parmary-color {
  background: $parmary-color;
}
.ClueEntry2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 2;
}
</style>
